module.exports = __webpack_public_path__ + "img/medio8.2cb3ea18.jpg";